import axios from 'axios';

// 根据项目配置，API代理路径为 /testapi/*
const API_BASE_URL = '/testapi';

// 邮箱查询服务
export const emailService = {
  // 查询邮箱最近的邮件
  async queryRecentEmails(email) {
    try {
      // 调用真实API接口
      const response = await axios.post(`${API_BASE_URL}/email/inbox_controller/fetchInboxEmails`, {
        email: email
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken') || ''}`
        },
        timeout: 30000 // 30秒超时
      });

      // 检查API返回结果
      if (response.data && response.data.success && response.data.code === 200) {
        return {
          success: true,
          data: {
            email: response.data.data.email,
            count: response.data.data.count,
            emails: response.data.data.emails || []
          }
        };
      } else {
        throw new Error(response.data?.message || 'API returned unsuccessful response');
      }
    } catch (error) {
      console.error('Email API call failed:', error);
      
      // 如果是网络错误或服务器错误，返回具体错误信息
      if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
        return {
          success: false,
          error: 'timeout',
          message: '请求超时，请稍后重试'
        };
      }
      
      if (error.response?.status >= 500) {
        return {
          success: false,
          error: 'server_error',
          message: '服务器错误，请稍后重试'
        };
      }
      
      if (error.response?.status === 404) {
        return {
          success: false,
          error: 'not_found',
          message: '该邮箱未找到相关邮件'
        };
      }
      
      // 对于开发环境，返回模拟数据
      if (process.env.NODE_ENV === 'development') {
        console.warn('Development mode: returning mock data');
        return {
          success: true,
          data: {
            email: email,
            count: 5,
            emails: getMockEmails(email)
          }
        };
      }
      
      // 生产环境返回错误
      return {
        success: false,
        error: 'api_error',
        message: error.response?.data?.message || '查询失败，请检查邮箱地址或稍后重试'
      };
    }
  },

  // 标记邮件为已读
  async markAsRead(emailId) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/email/mark-read`, {
        emailId: emailId
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken') || ''}`
        }
      });

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Mark as read failed:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
};

// 模拟邮件数据生成函数
function getMockEmails(email) {
  const now = new Date();
  const mockProviders = [
    { domain: 'github.com', name: 'GitHub', type: 'verification' },
    { domain: 'google.com', name: 'Google', type: 'security' },
    { domain: 'amazon.com', name: 'Amazon', type: 'delivery' },
    { domain: 'microsoft.com', name: 'Microsoft', type: 'verification' },
    { domain: 'taobao.com', name: '淘宝', type: 'payment' },
    { domain: 'alipay.com', name: '支付宝', type: 'payment' },
    { domain: 'jd.com', name: '京东', type: 'delivery' },
    { domain: 'apple.com', name: 'Apple', type: 'security' }
  ];

  const verificationTemplates = [
    { subject: '验证您的邮箱地址', preview: '您的验证码是：{code}，有效期10分钟' },
    { subject: '登录验证码', preview: '您正在尝试登录，验证码：{code}' },
    { subject: '账号安全验证', preview: '验证码：{code}，请勿告诉他人' },
    { subject: 'Email Verification', preview: 'Your verification code is: {code}' },
    { subject: 'Two-Factor Authentication', preview: 'Your 2FA code: {code}' }
  ];

  const paymentTemplates = [
    { subject: '支付成功通知', preview: '您的订单已支付成功，订单号：{orderId}' },
    { subject: '付款确认', preview: '您已成功支付 ¥{amount}' },
    { subject: 'Payment Received', preview: 'Payment of ${amount} has been processed' }
  ];

  const securityTemplates = [
    { subject: '安全提醒：新设备登录', preview: '我们注意到您的账号在新设备上登录' },
    { subject: '异常登录提醒', preview: '检测到来自 {location} 的登录尝试' },
    { subject: 'Security Alert', preview: 'New sign-in detected from {device}' }
  ];

  const deliveryTemplates = [
    { subject: '您的包裹已发货', preview: '您的订单已发货，预计{days}天送达' },
    { subject: '订单配送中', preview: '快递单号：{trackingNo}' },
    { subject: 'Package Shipped', preview: 'Your order is on the way' }
  ];

  // 生成5-10封随机邮件
  const emailCount = Math.floor(Math.random() * 6) + 5;
  const emails = [];

  for (let i = 0; i < emailCount; i++) {
    const provider = mockProviders[Math.floor(Math.random() * mockProviders.length)];
    let template;
    
    switch (provider.type) {
      case 'verification':
        template = verificationTemplates[Math.floor(Math.random() * verificationTemplates.length)];
        break;
      case 'payment':
        template = paymentTemplates[Math.floor(Math.random() * paymentTemplates.length)];
        break;
      case 'security':
        template = securityTemplates[Math.floor(Math.random() * securityTemplates.length)];
        break;
      case 'delivery':
        template = deliveryTemplates[Math.floor(Math.random() * deliveryTemplates.length)];
        break;
    }

    // 生成随机验证码
    const code = Math.floor(100000 + Math.random() * 900000).toString();
    const orderId = 'ORD' + Math.floor(1000000000 + Math.random() * 9000000000);
    const amount = (Math.random() * 1000 + 10).toFixed(2);
    const days = Math.floor(Math.random() * 5) + 2;
    const trackingNo = 'TRK' + Math.floor(100000000 + Math.random() * 900000000);
    const location = ['北京', '上海', '广州', '深圳', '纽约', '伦敦'][Math.floor(Math.random() * 6)];
    const device = ['iPhone', 'Android', 'Windows PC', 'MacBook'][Math.floor(Math.random() * 4)];

    // 替换模板中的占位符
    let preview = template.preview
      .replace('{code}', code)
      .replace('{orderId}', orderId)
      .replace('{amount}', amount)
      .replace('{days}', days)
      .replace('{trackingNo}', trackingNo)
      .replace('{location}', location)
      .replace('{device}', device);

    // 生成随机时间（最近7天内）
    const randomHours = Math.floor(Math.random() * 168); // 7天 * 24小时
    const emailDate = new Date(now.getTime() - randomHours * 3600000);

    emails.push({
      id: `mock-${i + 1}`,
      subject: `【${provider.name}】${template.subject}`,
      from: `noreply@${provider.domain}`,
      preview: preview,
      date: emailDate.toISOString(),
      isRead: Math.random() > 0.3, // 70%的邮件标记为已读
      type: provider.type
    });
  }

  // 按时间倒序排序
  emails.sort((a, b) => new Date(b.date) - new Date(a.date));

  return emails;
}

export default emailService;